import { metadata } from './metadata';
import { dimensions } from '../dimensions';
import { getChartOptions } from '../mapping';
import { colorDomain } from '../render';
import { visualOptions } from './visualOptions';
import { defaultOptionsValues } from '../defaultOptionsValues';

export const piechart = {
  metadata,
  dimensions,
  getChartOptions,
  colorDomain,
  visualOptions,
  defaultOptionsValues,
};
